import { useState, useEffect } from "react";
import { LuckydrawList } from "services/Api/Module/Luckydraw";

export const useLuckydraw = (limit, offset) => {
  const [luckydraws, setLuckydraws] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLuckydraws = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const { data } = await LuckydrawList({ params: { limit, offset } });

      if (data.resultCode === "20000") {
        setLuckydraws(data.resultData || []);
        setRowCount(data.rowCount || 0);
      } else {
        setError("Failed to fetch luckydraw data");
        setLuckydraws([]);
        setRowCount(0);
      }
    } catch (err) {
      console.error("Error fetching luckydraw list:", err);
      setError(err.message);
      setLuckydraws([]);
      setRowCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLuckydraws();
  }, [limit, offset]);

  return {
    luckydraws,
    rowCount,
    isLoading,
    error,
    refetch: fetchLuckydraws,
  };
};
